export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5168.d1b98ba7.jpg";